module.exports = __webpack_public_path__ + "img/word.8c2c5377.png";